import React, { PropsWithChildren } from 'react';
import { AccordionContent, AccordionHeader, AccordionItem, AccordionTitle, Text } from '@teliaee/design-system';

interface ISectionProps extends PropsWithChildren {
  id: string;
  title: string;
  subTitle?: React.ReactNode;
  icon: string;
}

const LoginMethodsAccordionItem = (props: ISectionProps): React.JSX.Element => {
  return (
    <AccordionItem id={props.id} icon={props.icon} background="neutral-bg-level-2">
      <AccordionHeader>
        <AccordionTitle className="h4 text-bold">{props.title}</AccordionTitle>
        <Text className="text-tiny" element="p">
          {props.subTitle}
        </Text>
      </AccordionHeader>
      <AccordionContent>{props.children}</AccordionContent>
    </AccordionItem>
  );
};

export default LoginMethodsAccordionItem;
